import { useLayoutMode } from '@/hooks/use-layout-mode';

import AimsLayout from '../AimsLayout';
import AppLayout from '../AppLayout';
import BackgroundLayout from '../BackgroundLayout';
import MinimalLayout from '../MinimalLayout';
import SplitLayout from '../SplitLayout';

const LayoutRouter = () => {
  const layout = useLayoutMode();

  switch (layout) {
    case 'split': {
      return <SplitLayout />;
    }
    case 'background': {
      return <BackgroundLayout />;
    }
    case 'minimal': {
      return <MinimalLayout />;
    }
    case 'aims': {
      return <AimsLayout />;
    }
    case 'default': {
      return <AppLayout />;
    }
  }
};

export default LayoutRouter;
